import warcraft1 from "../../../assets/images/background/warcraft/1.png";
import warcraft2 from "../../../assets/images/background/warcraft/2.png";
import warcraft3 from "../../../assets/images/background/warcraft/3.png";
import warcraft4 from "../../../assets/images/background/warcraft/4.png";
import warcraft5 from "../../../assets/images/background/warcraft/5.png";
import warcraft6 from "../../../assets/images/background/warcraft/6.png";
import warcraft7 from "../../../assets/images/background/warcraft/7.png";
import warcraft8 from "../../../assets/images/background/warcraft/8.png";
import warcraft9 from "../../../assets/images/background/warcraft/9.png";
import warcraft10 from "../../../assets/images/background/warcraft/10.png";
import warcraft11 from "../../../assets/images/background/warcraft/11.png";
import castle from "../../../assets/images/background/warcraft/castle.png";

const warcraft = {
	name: "Warcraft",
	components: {
		warcraft_1: {
			id: "warcraft_1",
			image: warcraft1,
			text: "warcraft tile 1",
			pois: { name: "", items: [] },
			walls: [
				{ x1: 0, y1: 41, x2: 59, y2: 41 },
				{ x1: 59, y1: 41, x2: 59, y2: 59 },
				{ x1: 59, y1: 59, x2: 0, y2: 59 },
			],
			waters: [],
		},
		warcraft_2: {
			id: "warcraft_2",
			image: warcraft2,
			text: "warcraft tile 2",
			pois: { name: "", items: [] },
			walls: [
				{ x1: 0, y1: 59, x2: 59, y2: 59 },
				{ x1: 59, y1: 59, x2: 59, y2: 0 },
				{ x1: 0, y1: 41, x2: 41, y2: 41 },
				{ x1: 41, y1: 41, x2: 41, y2: 0 },
			],
			waters: [],
		},
		warcraft_3: {
			id: "warcraft_3",
			image: warcraft3,
			text: "warcraft tile 3",
			pois: { name: "", items: [] },
			walls: [
				{ x1: 0, y1: 59, x2: 100, y2: 59 },
				{ x1: 0, y1: 41, x2: 41, y2: 41 },
				{ x1: 41, y1: 41, x2: 41, y2: 0 },
				{ x1: 59, y1: 0, x2: 59, y2: 41 },
				{ x1: 59, y1: 41, x2: 100, y2: 41 },
			],
			waters: [],
		},
		warcraft_4: {
			id: "warcraft_4",
			image: warcraft4,
			text: "warcraft tile 4",
			pois: { name: "", items: [] },
			walls: [
				{ x1: 0, y1: 59, x2: 100, y2: 59 },
				{ x1: 0, y1: 41, x2: 100, y2: 41 },
			],
			waters: [],
		},
		warcraft_5: {
			id: "warcraft_5",
			image: warcraft5,
			text: "warcraft tile 5",
			pois: { name: "", items: [] },
			walls: [
				{ x1: 13, y1: 41, x2: 87, y2: 41 },
				{ x1: 87, y1: 41, x2: 87, y2: 59 },
				{ x1: 87, y1: 59, x2: 13, y2: 59 },
				{ x1: 13, y1: 59, x2: 13, y2: 41 },
			],
			waters: [],
		},
		warcraft_6: {
			id: "warcraft_6",
			image: warcraft6,
			text: "warcraft tile 6",
			pois: { name: "", items: [] },
			walls: [
				{ x1: 41, y1: 0, x2: 41, y2: 41 },
				{ x1: 41, y1: 41, x2: 13, y2: 41 },
				{ x1: 13, y1: 41, x2: 13, y2: 59 },
				{ x1: 13, y1: 59, x2: 41, y2: 59 },
				{ x1: 41, y1: 59, x2: 41, y2: 100 },
				{ x1: 59, y1: 0, x2: 59, y2: 41 },
				{ x1: 59, y1: 41, x2: 87, y2: 41 },
				{ x1: 87, y1: 41, x2: 87, y2: 59 },
				{ x1: 87, y1: 59, x2: 59, y2: 59 },
				{ x1: 59, y1: 59, x2: 59, y2: 100 },
			],
			waters: [],
		},
		warcraft_7: {
			id: "warcraft_7",
			image: warcraft7,
			text: "warcraft tile 7",
			pois: { name: "", items: [] },
			walls: [],
			waters: [],
		},
		warcraft_8: {
			id: "warcraft_8",
			image: warcraft8,
			text: "warcraft tile 8",
			pois: { name: "", items: [] },
			walls: [
				{ x1: 0, y1: 41, x2: 87, y2: 41 },
				{ x1: 87, y1: 41, x2: 87, y2: 59 },
				{ x1: 87, y1: 59, x2: 0, y2: 59 },
			],
			waters: [],
		},
		warcraft_9: {
			id: "warcraft_9",
			image: warcraft9,
			text: "warcraft tile 9",
			pois: { name: "", items: [] },
			walls: [
				{ x1: 41, y1: 0, x2: 41, y2: 41 },
				{ x1: 41, y1: 41, x2: 13, y2: 41 },
				{ x1: 13, y1: 41, x2: 13, y2: 59 },
				{ x1: 13, y1: 59, x2: 41, y2: 59 },
				{ x1: 41, y1: 59, x2: 41, y2: 100 },
				{ x1: 59, y1: 0, x2: 59, y2: 41 },
				{ x1: 59, y1: 41, x2: 100, y2: 41 },
				{ x1: 100, y1: 59, x2: 59, y2: 59 },
				{ x1: 59, y1: 59, x2: 59, y2: 100 },
			],
			waters: [],
		},
		warcraft_10: {
			id: "warcraft_10",
			image: warcraft10,
			text: "warcraft tile 10",
			pois: { name: "", items: [] },
			walls: [
				{ x1: 0, y1: 41, x2: 41, y2: 41 },
				{ x1: 41, y1: 41, x2: 41, y2: 0 },
				{ x1: 59, y1: 0, x2: 59, y2: 41 },
				{ x1: 59, y1: 41, x2: 100, y2: 41 },
				{ x1: 100, y1: 59, x2: 59, y2: 59 },
				{ x1: 59, y1: 59, x2: 59, y2: 100 },
				{ x1: 0, y1: 59, x2: 41, y2: 59 },
				{ x1: 41, y1: 59, x2: 41, y2: 100 },
			],
			waters: [],
		},
		warcraft_11: {
			id: "warcraft_11",
			image: warcraft11,
			text: "warcraft tile 11",
			pois: { name: "", items: [] },
			walls: [
				{ x1: 0, y1: 59, x2: 100, y2: 59 },
				{ x1: 0, y1: 41, x2: 41, y2: 41 },
				{ x1: 41, y1: 41, x2: 41, y2: 11 },
				{ x1: 41, y1: 11, x2: 59, y2: 11 },
				{ x1: 59, y1: 11, x2: 59, y2: 41 },
				{ x1: 59, y1: 41, x2: 100, y2: 41 },
			],
			waters: [],
		},
		castle: {
			id: "castle",
			image: castle,
			text: "castle",
			pois: { name: "", items: [] },
			walls: [
				{ x1: 25, y1: 25, x2: 75, y2: 25 },
				{ x1: 75, y1: 25, x2: 75, y2: 75 },
				{ x1: 75, y1: 75, x2: 25, y2: 75 },
				{ x1: 25, y1: 75, x2: 25, y2: 25 },
			],
			waters: [],
		},
	},
};

export default warcraft;
